import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.uebersicht';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksUebersichtEffects {

    Uebersicht$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_UEBERSICHT),
        mergeMap((x: ac.GetUebersichtAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getUebersicht(x.uebersichtRequest).pipe(
                map((result: any) => {
                    return new ac.GetUebersichtErfolgreichAction(result, x.uebersichtRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetUebersichtFehlerAction(error, x.uebersichtRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ControllingQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ControllingQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ControllingQueryService);
        }
        return this.service;
    }
}
